import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import "./LoginScreen.css";

@inject("store")
@observer
class App extends Component {
  render() {
    const { store: { authStore: { buildInfo } } } = this.props;

    if (!buildInfo) {
      return "Build Info not initialized.";
    }

    return (
      <div>
        <h1>Build Info</h1>

        <ul>
          <li>
            Build Time: <b>{buildInfo["git.build.time"]}</b>
          </li>
          <li>
            Branch:{" "}
            <b>
              <a
                href={`https://bitbucket.org/cryptomania/jabot/commits/branch/${buildInfo["git.branch"]}`}
                target="bitbucket"
              >
                <code>{buildInfo["git.branch"]}</code>
              </a>
            </b>
          </li>
          <li>
            Commit:{" "}
            <b>
              <a
                href={`https://bitbucket.org/cryptomania/jabot/commits/${buildInfo["git.commit.id.full"]}`}
                target="bitbucket"
              >
                <code>{buildInfo["git.commit.id.abbrev"]}</code> {buildInfo["git.commit.message.short"]}{" "}
                <i>({buildInfo["git.commit.user.name"]})</i>
              </a>
            </b>
          </li>
          <li>
            Commit Time: <b>{buildInfo["git.commit.time"]}</b>
          </li>
        </ul>

        <pre>{JSON.stringify(buildInfo, null, 4)}</pre>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/screens/BuildInfo.js